import React from 'react';
import { ChildrenPropType } from '../../../../../../prop-types/children';
import style from './item-stock.module.less';

export const StockLevelWrapper = ({ children }) => <div className={style['stock-level-wrapper']}>{children}</div>;

StockLevelWrapper.propTypes = {
  children: ChildrenPropType.isRequired,
};
